import React from 'react';
import ServiceTimesReport from './ServiceTimesReport';
import { appPath, newAnalyticsPath } from "helpers/routePaths";

// This component is specifically for using ServiceTimesReport in the Analytics dashboard
// where we need to select a service via filters
const ServiceTimesAnalytics = () => {
  const { customCaptions } = JSON.parse(sessionStorage.getItem("me")) || JSON.parse(localStorage.getItem("me"));
  
  // Filters configuration specifically for the analytics version
  const filters = {
    timeframe: {
      allowCustomRange: true,
      defaultRange: 'show-all',
    },
    department: { multiSelect: true },
    service: {
      required: true
    }
  };

  return (
    <ServiceTimesReport 
      useFilters={true}
      analyticsMode={true}
      filtersConfig={filters}
      useDefaultNavigation={true} // Use ReportPage's default navigation
      customTitle={`Completed ${customCaptions?.service || 'Service'} Times by Work Order`}
    />
  );
};

export default ServiceTimesAnalytics; 